export const competitionInfo = {
  groups: [
    {
      title_cn: "2024年CST-开发者测试赛项",
      title_en: "Developer",
      group_number: "275420442",
    },
    {
      title_cn: "2024年CST-Web应用测试赛项",
      title_en: "Web",
      group_number: "529556532",
    },
    {
      title_cn: "2024年CST-嵌入式测试赛项",
      title_en: "Embedded",
      group_number: "634380184",
    },
    {
      title_cn: "2024年CST-车联网安全赛项",
      title_en: "V2X",
      group_number: "897313292",
    },
    {
      title_cn: "2024年CST-鸿蒙赛项",
      title_en: "Harmony",
      group_number: "897306216",
    },
  ],

  helpInfo: [
    // {
    //     title_cn: "2021年全国大赛指导视频",
    //     title_en: "2021 National Competition instruction video",
    //     link: "https://space.bilibili.com/437276739/video?keyword=%E5%A4%A7%E8%B5%9B",
    //     text_cn: "今年的大赛不再支持使用 WEBIDE 做题方式，请各位参赛选手自行准备好本地环境。比赛可以多次提交，成绩以最后一次提交为准。",
    //     text_en: "WEBIDE is not supported in this year's contest. Please prepare your own local environment. The competition may be submitted more than once, and the result will be determined by the last submission."
    // }, {
    //     title_cn: "2021年嵌入式大赛指导视频",
    //     title_en: "2021 Embedded Competition guidance video",
    //     link: "https://space.bilibili.com/242234013/channel/series"
    // },
    {
      title_cn: "大赛官网",
      title_en: "Competition official website",
      link: "http://www.mooctest.org/",
    },
    {
      title_cn: "教师端入口",
      title_en: "Teacher Management System Entrance",
      link: "http://manage.mooctest.net/",
    },
    {
      title_cn: "2023年省赛参考答案公布",
      title_en: "The announcement of reference answers in the 2023年省赛",
      link: "http://mooctest-user-server.oss-cn-shanghai.aliyuncs.com/2023%E7%9C%81%E8%B5%9B%E5%8F%82%E8%80%83%E7%AD%94%E6%A1%88%E5%85%AC%E5%B8%83/2023%E7%9C%81%E8%B5%9B%E5%8F%82%E8%80%83%E7%AD%94%E6%A1%88%E5%85%AC%E5%B8%83.zip",
    },
    {
      title_cn: "开发者赛项答案提交方式升级",
      title_en: "Upgraded submission method for developer competition",
      link: "https://www.bilibili.com/video/BV15S411w7TQ/",
    },
    {
      title_cn: "2024年练习赛参考答案公布",
      title_en: "The announcement of reference answers in the 2024年练习赛",
      emphasize: true,
      link: "http://mooctest-user-server.oss-cn-shanghai.aliyuncs.com/%E5%8F%82%E8%80%83%E7%AD%94%E6%A1%88%E5%85%AC%E5%B8%83/2024/%E7%BB%83%E4%B9%A0%E8%B5%9B%E5%8F%82%E8%80%83%E7%AD%94%E6%A1%88/2024%E7%BB%83%E4%B9%A0%E8%B5%9B%E5%8F%82%E8%80%83%E7%AD%94%E6%A1%88.zip",
    },
    {
      title_cn: "2024年车联网决赛部署环境",
      title_en: "The 2024 Internet of Vehicles Final Deployment Environment",
      emphasize: true,
      link: "http://mooctest-user-server.oss-cn-shanghai.aliyuncs.com/%E8%BD%A6%E8%81%94%E7%BD%91%E5%AE%89%E5%85%A8%E5%86%B3%E8%B5%9B_%E6%9C%AC%E5%9C%B0%E7%8E%AF%E5%A2%83%E9%83%A8%E7%BD%B2.zip",
    },
    {
      title_cn: "2024年预选赛参考答案公布",
      title_en: "The 2024 Qualifiers Reference Answers are announced",
      emphasize: true,
      link: "http://mooctest-user-server.oss-cn-shanghai.aliyuncs.com/%E5%8F%82%E8%80%83%E7%AD%94%E6%A1%88%E5%85%AC%E5%B8%83/2024/%E9%A2%84%E9%80%89%E8%B5%9B%E5%8F%82%E8%80%83%E7%AD%94%E6%A1%88/2024%E9%A2%84%E9%80%89%E8%B5%9B.zip",
    },
  ],
  qrCode: "http://www.mooctest.net/assets/img/summer/mooctest_wechat.jpg",
};
